import React, { Component } from 'react';
import { browserHistory } from 'react-router';

import PubSub from 'pubsub-js';

import './Setup.css';
import MyoSelector from '../components/MyoSelector';
import IconButton from '../components/IconButton';
import { myoService } from '../services/MyoService'; 
import { storageService } from '../services/StorageService'; 
import colors from '../colors';

class Setup extends Component {
  constructor(props) {
    super(props);

    this.state = {
      myos: myoService.getMyos(true)
    };

    this._handleMyoChanged = this._handleMyoChanged.bind(this);
    this._handleSelectionChanged = this._handleSelectionChanged.bind(this);
    this._handleNavNext = this._handleNavNext.bind(this);
  }

  componentDidMount() {
    PubSub.subscribe(myoService.topics.connected, this._handleMyoChanged);
    PubSub.subscribe(myoService.topics.disconnected, this._handleMyoChanged);
    PubSub.subscribe(myoService.topics.synced, this._handleMyoChanged);
    PubSub.subscribe(myoService.topics.unsynced, this._handleMyoChanged);
    PubSub.subscribe(myoService.topics.batteryLevel, this._handleMyoChanged);
  }

  componentWillUnmount() {
    PubSub.unsubscribe(myoService.topics.connected, this._handleMyoChanged);
    PubSub.unsubscribe(myoService.topics.disconnected, this._handleMyoChanged);
    PubSub.unsubscribe(myoService.topics.synced, this._handleMyoChanged);
    PubSub.unsubscribe(myoService.topics.unsynced, this._handleMyoChanged);
    PubSub.unsubscribe(myoService.topics.batteryLevel, this._handleMyoChanged);
  }

  render() {
    let { myos } = this.state;
    let style = this._getDefaultStyles();
    let navIconStyle = { width: 64, height: 64 };

    return (
      <div className="setup page" style={style}>
        <div className="content">
          <div className="heading">
            <h1>synchronize your devices</h1>
          </div>
          <div className="flex-row flex-fill">
            <div className="flex-fill"></div>
          <MyoSelector data={myos} onSelectionChanged={this._handleSelectionChanged} />
            <div className="flex-fill"></div>
          </div>
          <div className="navLeft flex-column flex-justify-items">
            <IconButton icon="chevron-left" iconStyle={navIconStyle}
                        onClick={this._handleNavBack}  />
          </div>
          <div className="navRight flex-column flex-justify-items">
            <IconButton icon="chevron-right" iconStyle={navIconStyle}
                        onClick={this._handleNavNext}  />
          </div>
        </div>
      </div>
    );
  }

  _getDefaultStyles() {
    let defaultStyle = {
      backgroundColor: colors.white,
    };

    return defaultStyle;
  }

  _handleMyoChanged(myo) {
    this.setState({
      myos: myoService.getMyos(true)
    });
  }

  _handleSelectionChanged(selected) {
    let ids = selected.map((myo) => { return myo.macAddress} );
    storageService.set(ids, storageService.stores.devices);
  }

  _handleNavNext() {
    browserHistory.push('/live');
  }

  _handleNavBack() {
    browserHistory.push('/splash');
  }
}

export default Setup;



/** WEBPACK FOOTER **
 ** ./src/containers/Setup.js
 **/